/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PersonRelationshipType {
  Child = 'Child',
  Mother = 'Mother',
  Father = 'Father',
  Parent = 'Parent',
  Spouse = 'Spouse',
  Partner = 'Partner'
}
